import React, { useEffect, useRef, useState } from 'react';
import { fontReport } from '../../../../apis/util';
import { PRINT_WIDTH } from '..';
import { Textareawithsteroids3 } from '../../../Ambition/EUGreenDeal/EUGreenDeal';
import eugreendealicon from '../../../../assets/shapes_svg/eugreendeal/eugreendeal_icon.svg';

export const EUGreenDeal2 = () => {
    const ref = useRef();
    const [width, setWidth] = useState(0);
    
    const sections = [
        {
            name:'tr',
            html:<h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,0.9/PRINT_WIDTH,"rem") }}>T.R <br/>(Taxonomy Regulation)</h6>
        },
        {
            name:'csrd',
            html:<h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,0.9/PRINT_WIDTH,"rem") }}>CSRD <br/>(Corporate Social Responsibility Directive)</h6>
        },
        {
            name:'csddd',
            html:<h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,0.9/PRINT_WIDTH,"rem") }}>CSDDD</h6>
        },
        {
            name:'sfdr',
            html:<h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,0.9/PRINT_WIDTH,"rem") }}>SFDR <br/>(Sustainable Finance Disclosure Regulation)</h6>
        },
        {
            name:'mifid',
            html:<h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,0.9/PRINT_WIDTH,"rem") }}>MiFID <br/>(Markets in Financial Instruments Directive)</h6>
        },
        {
            name:'idd',
            html:<h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,0.9/PRINT_WIDTH,"rem") }}>IDD <br/>(Insurance Distribution Directive)</h6>
        },
        {
            name:'efr',
            html:<h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,0.9/PRINT_WIDTH,"rem") }}>EFR</h6>
        }
    ]

    useEffect(() => {
        if (!ref.current) return;
        const resizeObserver = new ResizeObserver(() => {
            setWidth(ref.current.clientWidth);
        });
        resizeObserver.observe(ref.current);
        return () => resizeObserver.disconnect();
    }, []);
    return (
        <div className="ourenvironmentalaim" ref={ref}>
            <div className="ourenvironmentalaim__title">
                <h4 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.7/PRINT_WIDTH,"rem") }}>Our <strong>Directives</strong></h4>
                <img style={{width:"2.5%"}} src={eugreendealicon} alt="" />
            </div>
            {
                sections.map((directive) => {
                    return (
                        <div className="d-flex align-items-center justify-content-around directive__row">
                            <div className="directive__bubble">
                                {directive.html}
                            </div>
                            <div className="directive__description" style={{height:fontReport(width,PRINT_WIDTH,180/PRINT_WIDTH,"px")}}>
                                <Textareawithsteroids3 fontReport={fontReport(width,PRINT_WIDTH,14/PRINT_WIDTH,"px")} maxLength={3000} keyHighlight={directive.name} placeholder=""  disabled={true}></Textareawithsteroids3>
                            </div>
                        </div>
                    )
                    
                })
            }
        </div> 
    );
}